import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { verifyStatus } from "../../../actions/userActions";
import RejectButtonTax from "./RejectButtonTax";
import { Link, withRouter } from "react-router-dom";
import axios from "axios";
import $ from 'jquery';
import { Modal, Button } from "react-bootstrap";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import 'react-toastify/dist/ReactToastify.css';

import { toast, ToastContainer } from "react-toastify";
import {baseUrl} from "../../pages/baseUrl"
class VerifyDocument4 extends React.Component {

    constructor(props) {
        super(props);
        const { user } = this.props.auth;
        this.state = {
            records: [],
            id: "",
            frontimage: '',
            backimage: '',
            kycstatus: '',
            reject: '',
            errors: {},
            type: 24,
        };

    }

    componentWillReceiveProps(nextProps) {
   
        if (nextProps.record) {
         
            this.setState({
                id: nextProps.record._id,
                kycstatus: nextProps.record.kycstatus,
                frontimage: nextProps.record.docfrontimg,
                backimage: nextProps.record.docbackimg,
                reject: nextProps.record.rejectReason,
                records: nextProps.record,

            });
        }
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
        if (nextProps.userrecords) {
            this.setState({
                tstatus: nextProps.userrecords.status
            });
        }

    
    }
    componentDidMount(){


    }
    getNodesToRemoveFromElement = (stringContent) => {

        var div = document.createElement("div");
        div.innerHTML = stringContent;
        var text = div.textContent || div.innerText || "";
        return text;
    };

    onChange = e => {
        if (e.target.id === 'reject') {
            this.setState({ reject: e.target.value });
        }
    };
    handleCommentChange = (event, editor) => {

        var data = editor.getData();
        if (data) {
            this.setState({ description: data });
        }
        this.setState({
            showResults: this.state.name === null ? false : true
        })
    };
    getData() {
        const { user } = this.props.auth;
        axios
            .post(baseUrl + "/api/v1/getuserbyid", { id: this.props.match.params.id })
            .then(res => {
                this.setState({
                    d1: res.data.user.rejectReason,
                   
                }, () => {
                    this.setState({ isKycModalOpen: true })
                });
                console.log("res.datares.data", res.data)

            })
            .catch()
    }
    closeModel = () => {
        this.setState({ isKycModalOpen: false })
    }

    onUpdate = e => {

        e.preventDefault();
       
        const newUser = {
            id: this.props.match.params.id,
            type:"document"
        };
        this.props.verifyStatus(newUser);
    };



    render() {
        const { errors } = this.state;
        const { user } = this.state;
        return (
            <>
                {this.state.kycstatus &&
                    <>
                        <form noValidate onSubmit={this.onUpdate} id="update-user">
                            <p><b>Document :</b> {this.state.kycstatus=="Pending" ? "pending" : (this.state.kycstatus=="Verified" ? "Verified":
                             <button
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.getData()

                                }}
                                // to={
                                //   "/reject-reason/" + this.props.match.params.id + "/" + 22
                                // }
                                type="button"
                                className="btn btn_man"
                            >
                                Rejected <i className="fa fa-info-circle"></i>
                            </button>)}</p>
                            <a href={baseUrl+"/static/upload/selfie/" + this.state.frontimage} target="_blank"> <img src={baseUrl+"/upload/" + this.state.frontimage} className="img-thumbnail" alt="Cinque Terre"></img></a>
                            <a href={baseUrl+"/static/upload/selfie/" + this.state.backimage} target="_blank"> <img src={baseUrl+"/upload/" + this.state.backimage} className="img-thumbnail" alt="Cinque Terre"></img></a>
                           
                       
                            <div style={{ display: (this.state.kycstatus !== 'Verified' && this.state.kycstatus !== 'Rejected' ? 'block' : 'none') }}>
                                <button type="submit" className='btn btn-primary'>Verify</button>
                            </div>
                            
                            </form>
                            { this.state.kycstatus !== 'Verified' && this.state.kycstatus !== 'Rejected' &&
                            <RejectButtonTax record={this.state.records} kycStatus={this.state.kycstatus} rejectStatus={this.state.reject} />
                            }
                      
                        <hr />
                        <Modal
                            show={this.state.isKycModalOpen}
                            onHide={this.closeKycModal}
                            backdrop="static"
                            keyboard={false}
                        >
                            <Modal.Body>
                                <div className="kyc_popop tc">
                                    <h2 ref={(subtitle) => (subtitle = subtitle)}>
                                        <h3 className="man_hadding">Reject Reason</h3>
                                       
                                            <p className="rejectReason">{this.state.d1}</p>
                                        
                                       
                                    </h2>
                                    <div>
                                        <button className="w100px" onClick={this.closeModel}>
                                            Okay!
                                        </button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </>
                }
            </>
        )
    }
}

VerifyDocument4.propTypes = {
    verifyStatus: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
    mapStateToProps,
    { verifyStatus }
)(withRouter(VerifyDocument4));
